import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import { RootState } from '../..';
import apis from '../../../utils/apis';
import { OfferPayload } from '../../../components/Pipeline/LeadDetailsPage';
import { showFeedbackModal } from '../UserFeedbackActions';

interface FetchLeadsPayload {
  lawyerId: string;
  searchTerm?: string;
  filters?: { [key: string]: string[] };
  sortBy?: string;
  sortOrder?: string;
}

export const fetchLeads = (
  payload: FetchLeadsPayload
): ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch) => {
  try {
    dispatch({ type: 'FETCH_LEADS_REQUEST' });
    const response = await apis.post('/pipeline/get_leads', payload);
    dispatch({ type: 'FETCH_LEADS_SUCCESS', payload: response.data.leads });
  } catch (error) {
    dispatch({ type: 'FETCH_LEADS_FAILURE', error: (error as any).message });
  }
};

export const fetchLeadDetails = (leadId: string): ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch) => {
  try {
    const response = await apis.get(`/pipeline/lead/${leadId}`);
    dispatch({ type: 'FETCH_LEAD_DETAILS_SUCCESS', payload: response.data.lead });
  } catch (error) {
    dispatch({ type: 'FETCH_LEAD_DETAILS_FAILURE', error: (error as any).message });
  }
};

export const fetchCaseOrientation = (caseId: string): ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch) => {
  try {
    const response = await apis.get(`/cases/get_case_orientation/${caseId}`);
    dispatch({ type: 'FETCH_CASE_ORIENTATION_SUCCESS', payload: response.data.orientation });
  } catch (error) {
    dispatch({ type: 'FETCH_CASE_ORIENTATION_FAILURE', error: (error as any).message });
  }
};

export const submitOffer = (
    payload: { leadId: string; offer: OfferPayload }
  ): ThunkAction<void, RootState, unknown, AnyAction> => async (dispatch) => {
    try {
      await apis.post('/pipeline/submit_offer', payload);
      dispatch({ type: 'SUBMIT_OFFER_SUCCESS' });
      dispatch(showFeedbackModal({
        showModal: true,
        modalType: 'success',
        message: 'Offer submitted',
        duration: 3000
      }))
    } catch (error) {
      dispatch({ type: 'SUBMIT_OFFER_FAILURE', error: (error as any).message });
    }
  };